import { useEffect, useState } from 'react';
import {
  fetchPrizesForValidationResult,
  validatePrizeWinIdForUse,
} from 'utils/api/prizes';
import { getCookie } from 'utils/cookie';

export const useValidationResult = (
  setPrizesAreGroupedByPageSection: React.Dispatch<
    React.SetStateAction<boolean>
  >,
  prizeWinId?: string
) => {
  const [validationResult, setValidationResult] = useState<any | null>(null);

  useEffect(() => {
    (async () => {
      if (prizeWinId) {
        const jwt = getCookie('jwt');
        // Checks that there is an unclaimed prize associated with this prizeWinId, that it belongs to the currently logged-in user.
        const validationResult = await validatePrizeWinIdForUse(
          jwt,
          prizeWinId
        );
        setValidationResult(validationResult);
        setPrizesAreGroupedByPageSection(true);
      }
    })();
  }, [prizeWinId]);

  return {
    validationResult,
  };
};
